<!--
 * @Author: your name
 * @Date: 2021-02-03 14:29:16
 * @LastEditTime: 2021-09-28 11:51:56
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/components/global/TabManagePopupDialog/index.vue
-->
<style scoped lang="sass">
.van-popup
  width: 80% !important

.tab_dialog_container
  height: 100%
  width: 100%
  text-align: center

.button
  height: 56px
  font-size: 15px

.app_container
  display: flex
  flex-direction: column
  align-items: center

  .img_container
    margin-bottom: 20px
    width: 58px
    height: 58px

    .img
      margin: auto
      width: 100%
      height: 100%

.title
  margin-top: -5px
  margin-bottom: 20px
  font-size: 18px
  line-height: 22px
  color: var(--menu-primary-text-colour)

.content
  line-height: 18px
  font-size: 14px
  color: var(--menu-primary-text-colour)
  margin-bottom: 15px

.button_box
  width: 100%

.flex_column
  display: flex
  flex-direction: column

.second
  margin-top: 20px

::v-deep
  .van-popup
    display: flex
    flex-direction: column
    width: 283px
    padding: 0 10PX
    padding-top: 10PX

  .van-button--primary
    background: var(--menu-primary-background-colour)
    border: none
    border-radius: 4PX !important

.first_button
  margin-bottom: 15px

.second_button
  color: var(--menu-primary-background-colour)
  background: #fff !important
  border: 1px solid var(--menu-primary-background-colour)
</style>

<template lang="pug">
.tab_dialog_container
  BottomPopupDialog(
    :show="show"
    :showCloseIcon="false"
    :position="'center'"
    v-on="$listeners"
    v-bind="$attrs"
  )
    template(v-slot:popup-dialog)
      .app_container
        .img_container(v-if="showIcon")
          img.img(:src="warningIcon")
        .title.b {{ title }}
        .content.o75 {{ content }}
        .button_box(:class="{'flex_column': isFlexColumn}")
          van-button.button.b.first_button(type="primary" @click="clickHandlerFirstButton") {{ firstButtonText }}
          van-button.button.b.second_button(@click="clickHandlerSecondButton") {{ secondButtonText }}
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  model: {
    prop: 'show',
    event: 'changeShow'
  },

  props: {
    firstButtonText: {
      type: String,
    },

    secondButtonText: {
      type: String
    },

    show: {
      type: Boolean
    },

    isFlexColumn: {
      type: Boolean,
    },

    title: {
      type: String
    },

    content: {
      type: String
    },

    showIcon: Boolean
  }

})

class TabManagePopupDialog extends Vue {
  warningIcon = require('@/assets/tab-pics/warning-icon.png')

  clickHandlerFirstButton() {
    this.$emit('clickHandlerFirstButton')
    this.closeDialog()
  }

  clickHandlerSecondButton() {
    this.$emit('clickHandlerSecondButton')
    this.closeDialog()
  }

  closeDialog() {
    this.$emit('changeShow', false)
  }
}

export default TabManagePopupDialog
</script>
